//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapState } from 'vuex'
import moment from 'moment-timezone'

import TwitchPreFlightCheck from 'core/components/twitch-pre-flight-check.vue'
import defaultImage from 'core/img/announcements/retrolight.webp'
import announcementDetailsRegistry from './registry'

export default {
    name: 'StreamAnnouncement',

    data() {
        return {
            now: Date.now(),
            defaultImage,
        }
    },

    computed: {
        announcement() {
            return this.$store.getters.streamAnnouncement
        },

        streamDate() {
            if (!this.announcement) return null
            return new Date(this.announcement.stream_date).getTime()
        },

        isLive() {
            if (!this.announcement) return false
            return this.announcement.is_live
        },

        currentTitle() {
            if (this.isLive) return this.announcement.live_title
            return this.announcement.scheduled_title
        },

        currentDescription() {
            if (this.isLive) return this.announcement.live_description
            return this.announcement.scheduled_description
        },

        timeText() {
            if (!this.streamDate || this.isLive) return null

            const diff = this.streamDate - this.now
            if (diff <= 0) return 'Starting soon!'

            const ONE_HOUR = 1000 * 60 * 60
            if (diff < ONE_HOUR) {
                const minutes = Math.floor(diff / (1000 * 60))
                const seconds = Math.floor((diff % (1000 * 60)) / 1000)
                const parts = []
                if (minutes > 0) parts.push(`${minutes}m`)
                parts.push(`${seconds}s`)
                return `Starts in ${parts.join(' ')}`
            }

            const tz = moment.tz.guess()
            const d = new Date(this.streamDate)
            const mins = d.getMinutes()
            const hour = d.getHours() % 12 || 12
            const ampm = d.getHours() >= 12 ? 'PM' : 'AM'
            const time = mins ? `${hour}:${String(mins).padStart(2, '0')}${ampm}` : `${hour}${ampm}`
            const tzAbbr = moment().tz(tz).format('z')

            const today = new Date(this.now)
            const tomorrow = new Date(this.now)
            tomorrow.setDate(tomorrow.getDate() + 1)

            const isSameDay = d.toDateString() === today.toDateString()
            const isTomorrow = d.toDateString() === tomorrow.toDateString()

            if (isSameDay) {
                return `Today @ ${time} ${tzAbbr}`
            }
            if (isTomorrow) {
                return `Tomorrow @ ${time} ${tzAbbr}`
            }

            const ONE_WEEK = ONE_HOUR * 24 * 7
            let datePrefix
            if (diff < ONE_WEEK) {
                datePrefix = d.toLocaleString(undefined, { weekday: 'short' })
            } else {
                datePrefix = d.toLocaleString(undefined, { month: 'short', day: 'numeric' })
            }
            return `${datePrefix} @ ${time} ${tzAbbr}`
        },

        timeIcon() {
            if (!this.streamDate) return null
            const diff = this.streamDate - this.now
            if (diff <= 0) return 'fas fa-heart'
            return null
        },

        snoozeKey() {
            if (!this.announcement) return null
            return `stream_${this.announcement.id}_scheduled`
        },

        isSnoozed() {
            if (!this.snoozeKey) return false
            return !!this.streamSnoozes[this.snoozeKey]
        },

        isOptedOut() {
            return this.user?.no_streams
        },

        ...mapState({
            user: state => state.accounts.user,
            streamSnoozes: state => state.core.streamAnnouncementSnoozes,
        }),
    },

    methods: {
        handleClick(e) {
            this.$gtag.event('stream-announcement-click')
            if (this.isLive || !this.announcement.scheduled_details) {
                if (this.announcement.preflight) {
                    e.preventDefault()
                    this.$present(TwitchPreFlightCheck, { link: this.announcement.stream_url })
                }
            } else {
                e.preventDefault()
                this.$present(announcementDetailsRegistry[this.announcement.scheduled_details], {
                    announcement: this.announcement,
                })
            }
        },

        close() {
            this.snoozeStreamAnnouncement(this.snoozeKey)
        },

        ...mapMutations(['snoozeStreamAnnouncement']),
    },

    mounted() {
        this.$listenFor('TICK_SEC', () => {
            this.now = Date.now()
        })
    },
}
